/* LUXORA: COD button styled like Add to Cart (gold fill, dark spaced caps); glows on hover / click / tap.
   Optimised: only scans newly added DOM nodes (not the whole page on every change) so it no longer slows down the page or the COD form app. */
(function () {
  'use strict';

  var GOLD = '#e9c880';
  var DARK = '#1a0d0a';

  var CSS = ''
    + '.luxora-cod-glow{'
    + 'background:' + GOLD + ' !important;'
    + 'color:' + DARK + ' !important;'
    + 'border:1px solid ' + GOLD + ' !important;'
    + 'border-radius:0 !important;'
    + 'text-transform:uppercase !important;'
    + 'letter-spacing:.28em !important;'
    + 'font-size:.72rem !important;'
    + 'font-weight:500 !important;'
    + 'text-shadow:none !important;'
    + 'box-shadow:none !important;'
    + 'animation:none !important;'
    + 'cursor:pointer;'
    + 'transition:box-shadow .25s ease,transform .2s ease,filter .25s ease !important;}'
    + '.luxora-cod-glow *{color:' + DARK + ' !important;fill:' + DARK + ' !important;opacity:1 !important;text-transform:uppercase !important;letter-spacing:.28em !important;font-size:.72rem !important;font-weight:500 !important;text-shadow:none !important;}'
    + '.luxora-cod-glow:hover,.luxora-cod-glow:focus-visible,.luxora-cod-glow:active,.luxora-cod-glow.luxora-cod-pressed{'
    + 'filter:brightness(1.06);'
    + 'box-shadow:0 0 12px rgba(245,199,107,.9),0 0 30px rgba(245,199,107,.6) !important;}'
    + '.luxora-cod-glow:hover{transform:translateY(-1px);}'
    + '.luxora-cod-glow:active,.luxora-cod-glow.luxora-cod-pressed{transform:scale(.985);}';

  var style = document.createElement('style');
  style.setAttribute('data-luxora-cod-glow', '');
  style.textContent = CSS;
  document.head.appendChild(style);

  var RE = /order\s*now[\s\S]{0,6}cash\s*on\s*delivery|buy\s*with\s*cash\s*on\s*delivery|cash\s*on\s*delivery/i;
  var CLICKABLE = 'button, a, [role="button"]';
  var SKIP = '.pdp-card, .pdp-features, nav, footer, .rte, [data-pdp-init] .pdp-note';

  function check(el) {
    if (el.classList.contains('luxora-cod-glow')) return;
    /* cheap guards first: skip big containers before reading textContent */
    if (el.children.length > 4) return;
    if (el.closest(SKIP)) return;
    var txt = (el.textContent || '').trim();
    if (txt.length > 60 || !RE.test(txt)) return;
    if (!el.matches(CLICKABLE) && el.querySelector(CLICKABLE)) return;
    var btn = el.closest(CLICKABLE);
    if (!btn) {
      var p = el;
      while (p.parentElement && p !== document.body && !(p.offsetWidth >= 150 && p.offsetHeight >= 30)) p = p.parentElement;
      btn = p;
    }
    if (btn && btn !== document.body && !btn.classList.contains('pdp-add')) {
      btn.classList.add('luxora-cod-glow');
      /* only the innermost button keeps the style */
      var inner = btn.querySelector('.luxora-cod-glow');
      if (inner) btn.classList.remove('luxora-cod-glow');
      var outer = btn.parentElement && btn.parentElement.closest('.luxora-cod-glow');
      if (outer && outer !== btn) outer.classList.remove('luxora-cod-glow');
    }
  }

  function scan(root) {
    if (!root || root.nodeType !== 1 || !root.isConnected) return;
    if (root.tagName === 'SCRIPT' || root.tagName === 'STYLE') return;
    check(root);
    var nodes = root.querySelectorAll('button, a, [role="button"], div, span');
    var max = Math.min(nodes.length, 400);
    for (var i = 0; i < max; i++) check(nodes[i]);
  }

  /* keep the glow visible for a moment after a click or tap */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.luxora-cod-glow');
    if (!b) return;
    b.classList.add('luxora-cod-pressed');
    setTimeout(function () { b.classList.remove('luxora-cod-pressed'); }, 900);
  }, true);

  var pending = [];
  var timer = null;
  function flush() {
    timer = null;
    var list = pending;
    pending = [];
    for (var i = 0; i < list.length; i++) scan(list[i]);
  }
  function queue(node) {
    pending.push(node);
    if (!timer) timer = setTimeout(flush, 300);
  }

  function boot() {
    scan(document.body);
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) queue(added[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
